import React, { useState } from 'react';
import Button from './button';

const FiltersModal = ({ modalInstance, initialFilters, children }) => {
  const [filters, setFilters] = useState(initialFilters);

  const cancel = () => {
    modalInstance.dismiss('cancel');
  };

  const submit = () => {
    modalInstance.close(filters);
  };

  return (
    <div>
      <div className="modal-header">
        <a aria-hidden="true" className="close-modal" onClick={cancel} title="Close">
          <i className="icon-cross"></i>
        </a>
        <h4 className="modal-title">Filters</h4>
      </div>
      <div className="modal-body modal-body-visible">{children({ setFilters })}</div>
      <div className="modal-footer">
        <Button variant="hollow" onClick={cancel}>
          Cancel
        </Button>

        <Button variant="primary--v2" onClick={submit}>
          Done
        </Button>
      </div>
    </div>
  );
};

export default FiltersModal;
